import PropTypes from "prop-types";
import R from "ramda";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.number,
    role: PropTypes.string,
    firstName: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    preferenceEmail: PropTypes.bool,
    isPaid: PropTypes.bool,
  },
  {
    isAnonymous(u) {
      return this.role(u) === "anonymous";
    },
    notRegistered(u) {
      return R.isNil(u) || this.isAnonymous(u);
    },
    isRegistered(u) {
      return !this.notRegistered(u);
    },
    activeSubscription(u) {
      if (R.isNil(u)) {
        return null;
      }

      const activeSubscriptions = u.subscriptions.filter((sub) => sub.active);
      return activeSubscriptions.length ? R.last(activeSubscriptions) : null;
    },
  },
);
